// The operator's words, live. `$term('experience')` in any template, or `term()` in code,
// reads `settings/glossary` through one listener, started on first use. Only employees can
// read the document; anywhere else the defaults in schema/glossary.js stand.

import Vue from 'vue'
import { getFirestore, doc, onSnapshot } from 'firebase/firestore'
import { normalizeGlossary, termOf } from '@/schema/glossary'

const state = Vue.observable({ words: normalizeGlossary(null) })
let listening = false

function listen() {
  if (listening) return
  listening = true
  onSnapshot(
    doc(getFirestore(), 'settings', 'glossary'),
    (snap) => { state.words = normalizeGlossary(snap.exists() ? snap.data() : null) },
    // Not an employee, or not signed in yet: the defaults stand. Not retried, since
    // every render would ask again.
    () => {},
  )
}

/** term('instance', { plural: true }) → 'Tours'. */
export function term(key, opts) {
  listen()
  return termOf(state.words, key, opts)
}
